import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // <---- este importa @tailwind
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
